/**
 * src/components/ProductCard.jsx
 */
import { Link } from "react-router-dom";
import { PriceBlock } from "./PriceBlock";

export function ProductCard({ product, tone = "light" }) {
  const img = product.images[0];
  return (
    <Link to={`/product/${product.slug}`} className={`product-card ${tone === "onPrimary" ? "on-primary" : ""}`}>
      <div className="product-card-img-wrap">
        {img ? (
          <img src={img} alt={product.name} loading="lazy" width={900} height={1100} />
        ) : (
          <div style={{ width: "100%", height: "100%", display: "grid", placeItems: "center", fontSize: 40 }}>👗</div>
        )}
        {!product.anyAvailable && <span className="product-card-soldout-badge">Sold out</span>}
      </div>
      <h3 className="product-card-name">{product.name}</h3>
      <div className="mt-2">
        <PriceBlock price={product.priceFrom} comparePrice={product.compareFrom} size="sm" />
      </div>
    </Link>
  );
}